import { NavLinksType } from "../types";
import {
  Activity,
  Bill,
  Box,
  Chart,
  Grid3,
  Link,
  Money,
  People,
  Receipt,
  ReceiptDiscount,
  Setting5,
  Smileys,
  TruckFast,
  UserSearch,
  UserSquare,
  Wallet3,
  WalletMoney,
} from "iconsax-reactjs";
import { Megaphone } from "lucide-react";

const chooseColourBaseOnActiveState = (isActive: boolean) => {
  return isActive ? "#6F00FF" : "#6F739B";
};

const chooseIconVariantBaseOnActiveState = (isActive: boolean) => {
  return isActive ? "Bold" : "Outline";
};

export const NAV_LINKS: NavLinksType = {
  FIRST: [
    {
      text: "Dashboard",
      smallScreenText: "Dashboard",
      link: "/dashboard",
      icon: (isActive: boolean) => (
        <Grid3
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
  ],
  Customers: [
    {
      text: "KYB & Compliance",
      smallScreenText: "KYB",
      link: "/kyb-compliance",
      icon: (isActive: boolean) => (
        <UserSquare
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "All Customers",
      smallScreenText: "All Customers",
      link: "#",
      icon: (isActive: boolean) => (
        <People
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Ratings & Feedback",
      smallScreenText: "Ratings",
      link: "#",
      icon: (isActive: boolean) => (
        <Smileys
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
  ],
  Pay: [
    // Old transactions page link (commented out per requirement):
    // {
    //   text: "Transactions",
    //   smallScreenText: "Transact...",
    //   link: "/transaction/home",
    //   icon: (isActive: boolean) => (
    //     <Chart
    //       size={20}
    //       color={chooseColourBaseOnActiveState(isActive)}
    //       variant={chooseIconVariantBaseOnActiveState(isActive)}
    //     />
    //   ),
    // },
    {
      text: "Transactions",
      smallScreenText: "Transact...",
      link: "/transactions",
      icon: (isActive: boolean) => (
        <Chart
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Payment links",
      smallScreenText: "Payment",
      link: "#",
      icon: (isActive: boolean) => (
        <Link
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Bill Payments",
      smallScreenText: "Bill",
      link: "#",
      icon: (isActive: boolean) => (
        <Bill
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Invoices",
      smallScreenText: "Invoices",
      link: "/transfer/pay?tab=Invoices",
      icon: (isActive: boolean) => (
        <Receipt
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
  ],
  Finance: [
    {
      text: "Loans",
      smallScreenText: "Loans",
      link: "/finance?payment-requests",
      icon: (isActive: boolean) => (
        <Money
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Payment Requests",
      smallScreenText: "Payment Request",
      link: "#",
      icon: (isActive: boolean) => (
        <ReceiptDiscount
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Credit wallets",
      smallScreenText: "Credit Wallets",
      link: "#",
      icon: (isActive: boolean) => (
        <WalletMoney
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
  ],
  Flex: [
    {
      text: "Procurement",
      smallScreenText: "Procure...",
      link: "/flex",
      icon: (isActive: boolean) => (
        <Box
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Shipments",
      smallScreenText: "Shipments",
      link: "#",
      icon: (isActive: boolean) => (
        <TruckFast
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
  ],
  Admin: [
    {
      text: "Wallets",
      smallScreenText: "Wallets",
      link: "/wallet",
      icon: (isActive: boolean) => (
        <Wallet3
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Configurations",
      smallScreenText: "Configura...",
      link: "#",
      icon: (isActive: boolean) => (
        <Setting5
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Team Management",
      smallScreenText: "Team Manage...",
      link: "/team-management",
      icon: (isActive: boolean) => (
        <UserSearch
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Activity",
      smallScreenText: "Activity",
      link: "/activity",
      icon: (isActive: boolean) => (
        <Activity
          size={20}
          color={chooseColourBaseOnActiveState(isActive)}
          variant={chooseIconVariantBaseOnActiveState(isActive)}
        />
      ),
    },
    {
      text: "Broadcast",
      smallScreenText: "Broadcast",
      link: "/broadcast",
      icon: (isActive: boolean) => (
        <Megaphone
          size={20}
          color={isActive ?  "#FFFFFF" : "#6F739B"}
          strokeWidth={isActive ? .5 : 1.5}
          fill={isActive ? chooseColourBaseOnActiveState(isActive) : "none"}
        />
      ),
    },
    // {
    //   text: "Acount Settings",
    //   smallScreenText: "Acount Set...",
    //   link: "/account-settings",
    //   icon: (isActive: boolean) => (
    //     <Activity
    //       size={20}
    //       color={chooseColourBaseOnActiveState(isActive)}
    //       variant={chooseIconVariantBaseOnActiveState(isActive)}
    //     />
    //   ),
    // },
  ],
};
